const steps = [
  {
    number: "01",
    icon: "ri-water-flash-line",
    heading: "Book in Advance",
    body: "Lock in your preferred date online or by phone — we recommend at least 48 hours ahead, especially in peak season. Tell us your experience level and we'll sort the rest.",
  },
  {
    number: "02",
    icon: "ri-sailboat-line",
    heading: "Water Taxi to Mission Beach",
    body: "Take the Bedarra Island water taxi across to Mission Beach. It's a short, easy transfer — your reef day starts the moment you hit the water.",
  },
  {
    number: "03",
    icon: "ri-ship-2-line",
    heading: "Board MV Mahi-Mahi at Clump Point",
    body: "Meet your crew at Clump Point Jetty and board MV Mahi-Mahi. Briefings done, gear sorted, and you're outbound to the outer Great Barrier Reef.",
  },
  {
    number: "04",
    icon: "ri-bubble-chart-line",
    heading: "Dive or Snorkel Beaver Reef",
    body: "45–60 minutes offshore, Beaver Reef awaits. Certified divers go deep, first-timers go with a PADI instructor, snorkellers float above it all. The reef does the rest.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="w-full py-20 px-6 md:px-10" style={{ backgroundColor: "#f0f9f9" }}>
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-[3px] text-cyan-500 font-semibold mb-4">
            The Logistics
          </p>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-4">
            From Bedarra Island to the Reef — Here&apos;s How It Works
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto font-light leading-relaxed">
            Scuba diving from Bedarra Island is easier than you think. Four steps and you&apos;re on the outer reef.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="relative flex flex-col bg-white rounded-2xl p-7 border border-cyan-100">
              {/* Step number */}
              <span className="text-5xl font-black text-cyan-100 leading-none mb-4 select-none">
                {step.number}
              </span>
              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cyan-50 text-cyan-500 mb-4">
                <i className={`${step.icon} text-xl`} />
              </div>
              {/* Heading */}
              <h3 className="text-base font-bold text-gray-900 mb-2 leading-snug">
                {step.heading}
              </h3>
              {/* Body */}
              <p className="text-gray-500 text-sm leading-relaxed">
                {step.body}
              </p>

              {/* Connector arrow — hidden on last item and mobile */}
              {i < steps.length - 1 && (
                <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 items-center justify-center text-cyan-300 z-10">
                  <i className="ri-arrow-right-s-line text-2xl w-6 h-6 flex items-center justify-center" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA nudge */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://wa.me/61455957263?text=Hi!%20I'd%20like%20to%20book%20a%20dive%20trip%20to%20Bedarra%20Island."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold text-sm cursor-pointer hover:scale-105 transition-transform duration-300"
            style={{ boxShadow: "0 8px 24px rgba(249,115,22,0.35)" }}
          >
            <i className="ri-calendar-check-line w-4 h-4 flex items-center justify-center" />
            Book Your Dive Day Trip
          </a>
          <a
            href="tel:0455957263"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-4 rounded-full border-2 border-gray-300 text-gray-600 font-semibold text-sm cursor-pointer hover:border-gray-500 hover:text-gray-800 transition-all duration-200"
          >
            <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
            Call Us: 0455 957 263
          </a>
        </div>

      </div>
    </section>
  );
}
